import { effect, inject, Injectable, OnDestroy, signal, untracked } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import { RouteService } from './route.service';
import { TranslationService } from './translation.service';

@Injectable({
    providedIn: 'root'
})
export class TitleService implements OnDestroy {
    readonly currentPageTitle = signal('');
    readonly currentToolbarTitle = signal('');

    private languageSubscription = new Subscription();
    private routeSubscription = new Subscription();
    private readonly routeService = inject(RouteService);
    private readonly translationService = inject(TranslationService);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly router = inject(Router);

    constructor() {
        this.languageSubscription = this.translationService.onLanguageChanged.subscribe(() => this.getTranslations());
        this.routeSubscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                distinctUntilChanged()
            )
            .subscribe(() => this.getTranslations());

        effect(() => {
            const pageTitle = this.currentPageTitle();
            untracked(() => this.currentToolbarTitle.set(pageTitle));
        });
    }

    ngOnDestroy(): void {
        this.languageSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }

    private getTranslations(): void {
        const currentRoute = this.activatedRoute.root;
        let routeConfig = currentRoute.routeConfig;
        let firstChild = currentRoute.firstChild;

        while (!!firstChild) {
            routeConfig = firstChild.routeConfig;
            firstChild = firstChild.firstChild;
        }

        const routeData = this.routeService.getRouteData(routeConfig!);

        if (!!routeData) {
            const title = routeData.title;
            const titleParams = routeData.titleParams;

            if (!!titleParams) {
                this.translationService.getText(titleParams.value).subscribe(tParamVal =>
                    this.translationService.getText(`MenuItem.${title}`, { value: tParamVal }).subscribe(t => {
                        // what is of interest is, if title is set
                        // if it is not, we want the susbcription to be active anyways
                        // and clear the currently set title
                        this.currentPageTitle.set(title ? t : '');
                    })
                );
            } else {
                this.translationService.getText(`MenuItem.${title}`, titleParams).subscribe(t => {
                    // what is of interest is, if title is set
                    // if it is not, we want the susbcription to be active anyways
                    // and clear the currently set title
                    this.currentPageTitle.set(title ? t : '');
                });
            }
        }
    }
}
